import { minLength, required, email, sameAs } from 'vuelidate/lib/validators'

export const validation = {
  data () {
    return {
      fields: ['voornaam', 'achternaam', 'email', 'wachtwoord', 'voorwaarden']
    }
  },
  validations: {
    voornaam: {
      required,
      minLength: minLength(2)
    },
    achternaam: {
      required,
      minLength: minLength(2)
    },
    email: {
      required,
      email
    },
    wachtwoord: {
      required,
      minLength: minLength(8)
    },
    voorwaarden: {
      required,
      sameAs: sameAs( () => true )
    },
  }
}
